@if (initialized) {
  <!--  && contractsRuntime && contractsRuntime.contracts-->
  <!--  <h1>CONTRACTS</h1>-->

  <!--  [tableStyle]="{'min-width': '50rem'}"-->
  @if (uiContracts && uiContracts.length) {
    <p-table [value]="uiContracts" responsiveLayout="stack" [breakpoint]="'960px'">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th>Gesellschaft</th>
          <th>Typ</th>
          <th>Vertragsnummer</th>
          <th>Beginn</th>
          <!--        <th>Ende</th>-->
          <th>Status</th>
          <th>Beitrag</th>
          <!--          <th></th>-->
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-contract let-columns="columns">
        <tr (click)="showContract(contract)" class="cursor-pointer">
          <td>  @if (contract.insuranceCompany?.imageUrl) {
            <img style="object-fit: contain;" class="w-6rem" pTooltip="{{contract.insuranceCompany?.name }}"
                 [src]="contract.insuranceCompany?.imageUrl" [alt]="contract.insuranceCompany?.name"/>
          } @else {
            <span class="w-5rem">{{ contract.insuranceCompany?.name }}</span>
          }
          </td>
          <td class=""><span class="p-column-title ">Name</span>{{ contract.insuranceType?.name }}</td>
          <td><span class="p-column-title">Versicherungsscheinnummer</span>@if (contract.notFullyManaged) {
            <i class="pi pi-exclamation-triangle text-red-500"></i>
          }{{ contract.insuranceIdentNumber }}
          </td>
          <td>
            <div class="flex flex-column">
              <!--            Ticket DWK1000000764-->
              @if ((contract.startDate || contract.endDate) && (contract.startDate !== '1900-01-01' && contract.endDate !== '1900-01-01')) {
                <span>{{ contract.startDate | date:'dd.MM.yyyy' }}</span>
                <span *ngIf="contract.endDate" class="text-red-500">{{ contract.endDate | date:'dd.MM.yyyy' }}</span>
              } @else {
                -
              }
            </div>
          </td>
          <!--        <td><span class="p-column-title">Ende</span>{{contract.endDate}}</td>-->
          <td><span class="p-column-title">Status</span>
            <p-tag [value]="contract.contractStatusText" styleClass="px-2" [rounded]="true"
                   [severity]="contract?.contractStatus == 0 ? 'success' : contract?.contractStatus == 1 ? 'danger' :'warning'"
                   icon="pi pi-circle-fill pr-1"></p-tag>
          </td>
          <td>
            @if (contract?.freePayment) {
              <span class="font-semibold"> Beitragsfrei </span>
            } @else if (contract?.cost) {
              <span class="p-column-title">Preis</span><span class="font-semibold">{{ contract.cost?.formattedAmount }}
                <br/> {{ contract.paymentFrequencyText }}</span>
            } @else {
              -
            }


          </td>
          <!--          <td class="text-center">-->
          <!--            <p-button icon="pi pi-eye" (onClick)="showContract(contract)"></p-button>-->
          <!--          </td>-->
        </tr>
      </ng-template>
    </p-table>
  } @else {


  }


}
